import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type FieldElements = {
  input: SxProps
  inputLabel: SxProps
  inputSearch: SxProps
  helpTextContainer: SxProps
  blankSpace: SxProps
  helpText: SxProps
  helpErrorText: SxProps
  closeButton: SxProps
  closeIcon: SxProps
  popupIcon: SxProps
  tooltip: {
    sx: SxProps
  }
  autoCompleteOption: SxProps
  icon: SxProps
  wrapperLoader: SxProps
}

export const fieldsStyles: FieldElements = {
  input: {
    display: 'flex',
    height: '38px',
    flexGrow: 1,
    borderWidth: 1,
    borderColor: theme.colors.gray17,
    borderStyle: 'solid',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderRadius: '4px',

    '&.MuiAutocomplete-root.MuiAutocomplete-hasPopupIcon': {
      '& .MuiInputBase-root': {
        padding: theme.spacing(0, 1),
        paddingRight: '8px !important'
      },

      '& .MuiInputBase-input': {
        paddingRight: theme.spacing(1)
      }
    },

    '& .MuiInputBase-input': {
      height: 22,
      fontFamily: theme.corporate.secondaryFont,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '18px',
      color: theme.colors.gray14,

      '&::placeholder': {
        color: theme.colors.gray600
      }
    },

    '&.error:not(.disabled)': {
      borderColor: theme.corporate.errorColor,

      '&.Mui-focused': {
        borderColor: theme.corporate.errorColor
      },

      '& .MuiInputBase-root': {
        border: 'none'
      },

      '& .MuiOutlinedInput-root:hover': {
        borderBottomColor: theme.corporate.errorColor
      },

      '& + span': {
        color: theme.corporate.errorColor
      },

      '& .MuiSvgIcon-root': {
        color: theme.corporate.errorColor
      },

      '& .MuiAutocomplete-endAdornment': {
        '& .MuiAutocomplete-popupIndicator': {
          borderColor: theme.corporate.errorColor
        }
      }
    },

    '&:not(.error):hover': {
      backgroundColor: theme.corporate.color05
    },

    '&:not(.error).Mui-focused': {
      backgroundColor: theme.colors.white01,
      borderColor: theme.corporate.primaryColor,

      '& .MuiAutocomplete-endAdornment': {
        '& .MuiAutocomplete-popupIndicator': {
          borderColor: theme.corporate.primaryColor
        }
      }
    },

    '&.disabled': {
      backgroundColor: theme.colors.gray50,
      borderColor: theme.colors.gray300,

      '&:hover': {
        backgroundColor: theme.colors.gray50,
        borderColor: theme.colors.gray300
      },

      '& .MuiSvgIcon-root': {
        fill: theme.colors.gray16
      },

      '& .MuiAutocomplete-endAdornment': {
        '& .MuiAutocomplete-popupIndicator': {
          borderColor: theme.colors.gray300
        }
      }
    },

    '&.MuiInputBase-multiline': {
      height: 'auto',
      padding: '10px',
      '.MuiButtonBase-root': {
        display: 'none'
      },
      '&:focus, &:active, &:hover': {
        '.MuiButtonBase-root': {
          display: 'block'
        }
      },
      '&:focus': {
        '.MuiButtonBase-root': {
          display: 'block'
        }
      }
    },

    '&.MuiInputBase-multiline.Mui-focused': {
      '.MuiButtonBase-root': {
        display: 'block'
      }
    },

    '& .MuiOutlinedInput-root': {
      border: 'none',

      '&:hover': {
        // borderBottom: theme.corporate.borderBottom
      },

      '&.Mui-focused': {
        // borderBottom: theme.corporate.borderBottom
      }
    },

    '&.MuiFormControl-root': {
      '& legend': {
        minWidth: 'auto'
      },
      '& .MuiOutlinedInput-root': {
        border: 'none'
      }
    },

    '&.clearable .MuiSvgIcon-root': {
      fontSize: '12px',
      cursor: 'pointer'
    },

    '&.clearable': {
      '&.error .euro': {
        color: theme.corporate.errorColor
      },

      '& .MuiSvgIcon-root': {
        fontSize: '18px',
        cursor: 'pointer',
        marginLeft: '8px',

        '&:first-of-type': {
          display: 'none'
        }
      },

      '&:hover': {
        '& .MuiSvgIcon-root': {
          display: 'block'
        }
      },

      '& .inputSearchIcon': {
        color: theme.corporate.primaryColor,
        borderLeft: `1px solid ${theme.corporate.primaryColor}`,
        display: 'block',
        marginLeft: '4px',
        cursor: 'default',

        '& .MuiSvgIcon-root:first-of-type': {
          display: 'block'
        }
      }
    },

    '& .MuiAutocomplete-endAdornment': {
      position: 'relative',
      right: 'unset !important',
      top: 'unset !important',
      flex: '0 0 auto',
      height: 22,

      '& button': {
        borderRadius: 0,
        paddingBottom: 0,
        paddingTop: 0
      },

      '& .MuiAutocomplete-popupIndicator': {
        paddingLeft: theme.spacing(1),
        borderLeft: `1px solid ${theme.colors.gray17}`
      },

      '& .MuiAutocomplete-popupIndicatorOpen': {
        paddingLeft: '2px',
        paddingRight: theme.spacing(1),
        borderLeft: 'none',
        borderRight: `1px solid ${theme.colors.gray17}`
      },

      '& .MuiAutocomplete-clearIndicator': {
        marginRight: theme.spacing(1)
      }
    },

    '& .MuiAutocomplete-clearIndicator': {
      visibility: 'hidden',

      '& .MuiSvgIcon-root': {
        fill: theme.corporate.primaryColor
      }
    },

    '&:hover .MuiAutocomplete-clearIndicator': {
      visibility: 'visible'
    },

    '&.Mui-focused .MuiAutocomplete-clearIndicator': {
      visibility: 'visible'
    },

    '& .wrapperIconCoin': {
      width: 22,
      height: 22,
      paddingRight: '6px',
      marginRight: '8px',
      borderRight: `1px solid ${theme.colors.gray17}`,
      boxSizing: 'content-box',

      '& .MuiSvgIcon-root': {
        display: 'flex !important',
        fontSize: 20,
        margin: 0,
        fill: theme.corporate.primaryColor
      }
    },

    '&.error:not(.disabled) .wrapperIconCoin': {
      borderColor: theme.corporate.errorColor
    },

    '&.disabled .wrapperIconCoin .MuiSvgIcon-root': {
      fill: theme.colors.gray16
    },

    '&.Mui-focused:not(.error) .wrapperIconCoin': {
      borderColor: theme.corporate.primaryColor
    },

    '& .iconClean': {
      fill: theme.corporate.primaryColor
    },

    '& .wrapperRightIcon': {
      width: 22,
      height: 22,
      paddingLeft: '6px',
      marginLeft: '8px',
      borderLeft: `1px solid ${theme.colors.gray17}`,
      boxSizing: 'content-box'
    },

    '&.error:not(.disabled) .wrapperRightIcon': {
      borderColor: theme.corporate.errorColor
    },

    '&.disabled .wrapperRightIcon .MuiSvgIcon-root': {
      fill: theme.colors.gray16
    },

    '&.Mui-focused:not(.error) .wrapperRightIcon': {
      borderColor: theme.corporate.primaryColor
    }
  },

  inputLabel: {
    padding: 0,
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '20px',
    marginBottom: '2px',

    '&.MuiInputLabel-root.required:after': {
      top: 0,
      fontSize: 22
    },

    span: {
      color: '#cc0000'
    }
  },

  inputSearch: {
    width: '100%',
    borderColor: theme.colors.gray17,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '4px',
    backgroundColor: theme.colors.white01,
    padding: theme.spacing(0, 1),

    '& .MuiInputBase-input': {
      color: theme.colors.gray14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontFamily: theme.corporate.secondaryFont,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '18px',
      marginRight: theme.spacing(1)
    },

    '& .MuiSvgIcon-root': {
      display: 'block',
      fontSize: '22px',
      fill: theme.colors.gray16,
      cursor: 'pointer'
    },

    '& .inputCleanIcon': {
      display: 'none',
      marginRight: theme.spacing(1),
      height: '22px',
      flex: '0 0 22px',

      '& .MuiSvgIcon-root': {
        fontSize: '16px'
      }
    },

    '& .MuiInputBase-input:not([value=""]) + .inputCleanIcon': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    '& .inputSearchIcon': {
      display: 'block',
      borderLeft: `1px solid ${theme.colors.gray17}`,
      paddingLeft: theme.spacing(1),
      cursor: 'default'
    },

    '&.error': {
      borderColor: theme.colors.red01,

      '& .errorSpan': {
        position: 'absolute',
        top: '40px',
        left: '0px',
        fontSize: '12px',
        color: theme.colors.red01
      }
    },

    '&.disabled': {
      backgroundColor: theme.colors.gray50
    },

    '&:hover': {
      backgroundColor: theme.colors.blue08
    },

    '&.Mui-focused': {
      borderColor: theme.corporate.primaryColor,
      backgroundColor: theme.colors.white01,

      '& .MuiSvgIcon-root': {
        fill: theme.corporate.primaryColor
      },

      '& .inputSearchIcon': {
        borderColor: theme.corporate.primaryColor
      }
    },

    '&.launched': {
      '& .MuiSvgIcon-root': {
        fill: theme.corporate.primaryColor
      },

      '& .inputSearchIcon': {
        borderColor: theme.corporate.primaryColor
      }
    }
  },

  helpTextContainer: {
    marginTop: '4px',
    marginBottom: '4px',
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    color: theme.colors.gray600,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px'
  },

  blankSpace: {
    display: 'block',
    minHeight: '23px'
  },

  helpText: {
    display: 'block',
    minHeight: '18px',
    fontSize: '14px',
    fontFamily: theme.corporate.primaryFont,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    color: theme.colors.gray03,
    marginTop: '2px',

    '.error:not(.disabled) &': {
      color: theme.corporate.errorColor
    }
  },

  helpErrorText: {
    display: 'block',
    minHeight: '18px',
    fontSize: '14px',
    fontFamily: theme.corporate.primaryFont,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    color: theme.corporate.errorColor
  },

  closeButton: {
    color: theme.corporate.primaryColor,
    alignSelf: 'flex-start',
    padding: '0px'
  },

  closeIcon: {
    fontSize: 18
  },

  popupIcon: {
    fontSize: 22,
    fill: theme.corporate.primaryColor
  },

  tooltip: {
    sx: {
      color: theme.colors.gray14,
      backgroundColor: theme.colors.blue08,
      maxWidth: 500,
      fontFamily: theme.corporate.primaryFont,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '18px',
      padding: theme.spacing(1),
      boxShadow: '0px 1px 3px 0px rgba(113, 113, 113, 0.25)'
    }
  },

  autoCompleteOption: {
    '& .materia-no-seleccionable': {
      color: theme.colors.gray03,
      pointerEvents: 'none'
    },
    '& .custom-materia-option--bold': {
      fontWeight: 'bold',
      borderTop: `1px solid ${theme.colors.gray03}`
    }
  },

  icon: {
    '&.MuiIconButton-root.Mui-disabled': {
      opacity: 0.5,
      pointerEvents: 'none'
    }
  },

  wrapperLoader: {
    width: 22,
    height: 22
  }
}
